import React, { useEffect, useRef, useState } from "react";
import useApi from "../hooks/useApi";
import { apiUrls } from "../utils/api/apiUrls";
import { useClickAway } from "react-use";

const NotificationSidebar = ({ closeNotificationSidebar }) => {
  const { data = [], apiCall } = useApi(false);
  const [isNotificationReponseSuccess, setIsNotificationReponseSuccess] = useState(false)
  const [state, setState] = useState(1);

  const changeHandler = (v) => {
    setState(v);
  };

  const notificationSidebarRef = useRef();

  useClickAway(notificationSidebarRef, () => {
    closeNotificationSidebar(false);
  });

  useEffect(() => {
    // getNotification
    apiCall({
      url: apiUrls.sso.getNotifications,
      method: "get",
      onSuccess: (data) => {
        setIsNotificationReponseSuccess(true)
        // setStoreDropdownState(data);
      },
    });
  }, []);

  return (
    <div className="flex absolute top-[0px] left-[0px] h-full w-full overflow-auto" style={{zIndex: '9999'}}>
      {/* <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          //   // animate={{ x: 100 }}
          transition={{ duration: 0.1 }}
          ref={notificationSidebarRef}
        > */}
          <div
            className="fixed bg-white"
            ref={notificationSidebarRef}
            style={{
              right: "0px",
              top: "0px",
              width: "330px",
              height: "100vh",
              zIndex: "99999",
              boxShadow: '0px 0px 6px #00000029'
            }}
          >
            {/* Notification and Annoucement */}
            <div
              style={{
                width: "20px",
                position: "absolute",
                left: "-20px",
                top: "4px",
                // padding: '4px',
                // paddingRight: '6px',
              }}
              className="cursor-pointer rounded-s-md py-2 px-3 bg-red-600 text-white"
              onClick={closeNotificationSidebar}
            >
              <span className=" text-xl font-bold ">X</span>
            </div>
            <div
              className=" flex justify-between"
              style={{ borderBottom: "1px solid #D9D9D9" }}
            >
              <span
                className={
                  state === 1
                    ? "border-b-4 text-2xl py-2 cursor-pointer hover:bg-sky-100"
                    : "text-2xl py-2 cursor-pointer hover:bg-sky-100"
                }
                onClick={() => changeHandler(1)}
                style={{ paddingRight: "36px", paddingLeft: "36px" }}
              >
                Notification
              </span>
              <span
                className={
                  state === 2
                    ? "border-b-4 text-2xl py-2 cursor-pointer hover:bg-sky-100"
                    : "text-2xl py-2 cursor-pointer hover:bg-sky-100"
                }
                onClick={() => changeHandler(2)}
                style={{ paddingRight: "36px", paddingLeft: "36px" }}
              >
                Announcements
              </span>
            </div>

            <div className="mt-4 flex w-full justify-center">
              {state === 1 && (
                <div className="overflow-auto" style={{ height: '93vh' }}>
                  {data.length > 0 ? (
                    data?.map((msg, ind) => {
                      return (
                        <div
                          key={ind}
                          className="px-6 mt-4 py-4 mcd-bg-color mcd-font-regular text-xl border-radius-6 border mx-6 rounded-md bg-slate-100"
                        >
                          <span className="">{msg?.text || ""}</span>
                        </div>
                      );
                    })
                  ) : (
                    <div className="flex justify-center items-center mt-6 text-2xl w-full font-medium">
                      {isNotificationReponseSuccess ? "No Data" : "Loading..." }
                    </div>
                  )}
                </div>
              )}
              {state === 2 && (
                <div className="px-6 py-2 mcd-bg-color mcd-font-regular text-xl border-radius-6 font-medium">
                  Announcements
                </div>
              )}
            </div>
          </div>
        {/* </motion.div>
      </AnimatePresence> */}
    </div>
  );
};

export default NotificationSidebar;
